import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PostPage } from '../models/post-page.model';
import { ContactMessage } from '../models/contact-message.model';
import { ReferralInfo } from '../models/referral-info.model';

@Injectable()
export class PortalService {

  private api: string = '/api/pp';

  constructor(private http: HttpClient) {
  }

  public getSideNavigation(): Observable<any> {
    return this.http.get<any>(`${this.api}/side_navigation`);
  }

  public getPosts(pageNumber: number, pageSize: number, type: string): Observable<PostPage> {
    return this.http.get<PostPage>(`${this.api}/${type}/posts/${pageNumber}?page_size=${pageSize}`);
  }

  public getPostFile(postId: number, fileId: number): Observable<Blob> {
    return this.http.get(`${this.api}/posts/${postId}/files/${fileId}`, { responseType:"blob", withCredentials: true });
  }

  public postMessage(message: ContactMessage): Observable<any> {
    return this.http.post<any>(`${this.api}/contact_message`, message);
  }

  public getReferralInfo(referralNumber: string): Observable<ReferralInfo> {
    return this.http.get<ReferralInfo>(`${this.api}/referrals/${referralNumber}`);
  }
}
